import {
    GET_CONTACT_LIST_REQUEST,
    GET_CONTACT_LIST_SUCCESS,
    GET_CONTACT_LIST_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const getContactListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CONTACT_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case GET_CONTACT_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case GET_CONTACT_LIST_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default getContactListReducer;